import React from "react";
import { Box, Container, Stack } from "@mui/system";
import { Paper, Typography } from "@mui/material";
import useResponsive from "../../hooks/useResponsive";
import jbtLogo from "../../assets/jbt-logo.png";
import dayjs from "dayjs";
import ApplicationForm from "../../components/application/ApplicationForm";
import { ApplicationProvider } from "../../context/ApplicationContext";
import useApplicationProcess from "../../hooks/applications/useApplicationProcess";
import LoadingCircle from "../../components/general/LoadingCircle";

/**
 * This component displays the application phase for the Junior Business Team
 * @returns the application component
 */
const Application = () => {
  const { applicationPhase, isApplicationPhaseLoading, saveApplication } = useApplicationProcess();
  const isMobile = useResponsive("down", "sm");

  if (!applicationPhase || isApplicationPhaseLoading) {
    return <LoadingCircle />;
  }

  // Check if the application phase has not yet started
  if (applicationPhase.applicationStart !== null && dayjs(applicationPhase.applicationStart).isAfter(dayjs())) {
    return (
      <Container
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
          minWidth: "100vw",
          background: "#f1f1f1",
        }}
      >
        <Paper
          elevation={3}
          sx={{
            minHeight: "50vh",
            minWidth: isMobile ? "80vw" : "55vw",
            borderRadius: 20,
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
          }}
        >
          <Stack justifyContent={"center"} alignItems={"center"} spacing={6}>
            <Box
              sx={{ maxHeight: isMobile ? "40vh" : "25vh", maxWidth: isMobile ? "40vw" : "25vw" }}
              component="img"
              src={jbtLogo}
            />
            <Typography variant="body1" textAlign={"center"} fontSize={20}>
              Die Bewerbungsphase für das <strong>{applicationPhase.description}</strong> {isMobile ? " " : <br />}
              beginnt erst am <strong>{dayjs(applicationPhase.applicationStart).format("DD.MM.YYYY")}</strong> um{" "}
              <strong>{dayjs(applicationPhase.applicationStart).format("HH:mm")} Uhr</strong>.
            </Typography>
          </Stack>
        </Paper>
      </Container>
    );
  }

  // Check if the application phase is currently running
  if (
    applicationPhase.applicationStart !== null &&
    applicationPhase.applicationEnd !== null &&
    dayjs(applicationPhase.applicationStart).isBefore(dayjs()) &&
    dayjs(applicationPhase.applicationEnd).isAfter(dayjs())
  ) {
    return (
      <ApplicationProvider>
        <ApplicationForm applicationPhase={applicationPhase} saveApplication={saveApplication} />
      </ApplicationProvider>
    );
  }

  // Else the application phase has ended
  return (
    <Container
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        minWidth: "100vw",
        background: "#f1f1f1",
      }}
    >
      <Paper
        elevation={3}
        sx={{
          minHeight: "50vh",
          minWidth: isMobile ? "80vw" : "55vw",
          borderRadius: 20,
          justifyContent: "center",
          alignItems: "center",
          display: "flex",
        }}
      >
        <Stack justifyContent={"center"} alignItems={"center"} spacing={6}>
          <Box
            sx={{ maxHeight: isMobile ? "40vh" : "25vh", maxWidth: isMobile ? "40vw" : "25vw" }}
            component="img"
            src={jbtLogo}
          />
          <Typography variant="body1" textAlign={"center"} fontSize={20}>
            Die Bewerbungsphase für das <strong>{applicationPhase.description}</strong> ist beendet.
          </Typography>
        </Stack>
      </Paper>
    </Container>
  );
};

export default Application;
